import React from "react";
import "./Waves.css";
import waveSVG from "./assets/waves.svg";
import { useLocation } from "react-router-dom";

const Waves = () => {
  const location = useLocation();
  const waveClass =
    location.pathname === "/about"
      ? "wave-container about"
      : location.pathname === "/media"
      ? "wave-container media"
      : location.pathname === "/"
      ? "wave-container home"
      : location.pathname === "/contact"
      ? "wave-container contact"
      : "wave-container";
  return (
    <div className={waveClass}>
      <div
        className="wave wave-1"
        style={{
          maskImage: `url(${waveSVG})`,
          WebkitMaskImage: `url(${waveSVG})`,
        }}
      ></div>
      <div
        className="wave wave-2"
        style={{
          maskImage: `url(${waveSVG})`,
          WebkitMaskImage: `url(${waveSVG})`,
        }}
      ></div>
      <div
        className="wave wave-3"
        style={{
          maskImage: `url(${waveSVG})`,
          WebkitMaskImage: `url(${waveSVG})`,
        }}
      ></div>
      <div
        className="wave wave-4"
        style={{
          maskImage: `url(${waveSVG})`,
          WebkitMaskImage: `url(${waveSVG})`,
        }}
      ></div>
    </div>
  );
};

export default Waves;
